import React from "react";
import { AnswerInput, QuestionOptionValue } from "../../../../../api/src/types";

import {
  PopupPrimaryButton,
  PopupSecondaryButton,
} from "../../../components/popups/Popup";
import {
  ParagraphHeaderLarge,
  ParagraphHeader,
} from "../../../components/typography/Paragraph";
import CloseIcon from "../../../components/icons/CloseIcon";
import { Card } from "../../../components/layout/Card";
import {
  ModalHeader,
  QuestionSection,
  StyledCloseButton,
  CardFooter,
  ModalContainer,
  StyledOverlay,
} from "./DisputeComponents";
import { ReadOnlyAnswerDisplay } from "./ReadOnlyAnswerDisplay";

interface AcceptDisputeModalProps {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  questionTitle: string;
  answerToShow: AnswerInput;
  questionOptions: QuestionOptionValue[];
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  inputType?: string | null;
}

export const AcceptDisputeModal: React.FC<AcceptDisputeModalProps> = ({
  onClose,
  onConfirm,
  title,
  questionTitle,
  answerToShow,
  questionOptions,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  inputType,
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <StyledOverlay
      onClick={handleOverlayClick}
      data-testid="dispute-confirmation-popup"
    >
      <ModalContainer>
        <Card>
          <ModalHeader>
            <ParagraphHeader fontWeight={700}>{title}</ParagraphHeader>
            <StyledCloseButton onClick={onClose}>
              <CloseIcon />
            </StyledCloseButton>
          </ModalHeader>

          <QuestionSection>
            <ParagraphHeaderLarge>{questionTitle}</ParagraphHeaderLarge>
            <ReadOnlyAnswerDisplay
              answer={answerToShow}
              questionOptions={questionOptions}
              isChecked={true}
              inputType={inputType ?? null}
            />
          </QuestionSection>

          <CardFooter>
            <PopupSecondaryButton onClick={onClose} disabled={isLoading}>
              {cancelText}
            </PopupSecondaryButton>
            <PopupPrimaryButton onClick={onConfirm} disabled={isLoading}>
              {confirmText}
            </PopupPrimaryButton>
          </CardFooter>
        </Card>
      </ModalContainer>
    </StyledOverlay>
  );
};
